import { WSInfoBox, WSProgressBar } from "@wingspanhq/fe-component-library";
import React from "react";
import {
  SharedFileRequestJobStatus,
  SharedFileRequestJobType
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { VALIDATION_ITEM_WARNING_STATUS } from "../../../components/AIValidationWidget/ValidationItem";

type Job = {
  type: insuranceImportApiSpec.InsuranceImportJob["type"];
  // `Warning` predates the installed types; see `helpers/insuranceWarnings.ts`
  status?:
    | insuranceImportApiSpec.InsuranceImportJob["status"]
    | typeof VALIDATION_ITEM_WARNING_STATUS;
};

export const ValidationProgress: React.FC<{
  jobs?: Job[];
  isBackgroundValidation?: boolean;
}> = ({ jobs, isBackgroundValidation = true }) => {
  const validations = jobs?.filter(
    job => job.type === SharedFileRequestJobType.Validation
  );

  if (!validations?.length) {
    return null;
  }

  const finished = validations.filter(
    job =>
      job.status === SharedFileRequestJobStatus.Complete ||
      job.status === SharedFileRequestJobStatus.Failed ||
      job.status === SharedFileRequestJobStatus.Error ||
      job.status === VALIDATION_ITEM_WARNING_STATUS
  );

  const allLength = validations.length;
  const finishedLength = finished.length;

  const percent = Math.round((finishedLength / allLength) * 100);

  const description =
    finishedLength === allLength
      ? "All validations completed. Finalizing..."
      : finishedLength === 0
      ? "Pending, validation will begin shortly..."
      : `${finishedLength} of ${allLength} validations checked. ${
          isBackgroundValidation
            ? "If you close this page, the progress will continue until it is completed."
            : ""
        }`;
  const descriptionIcon =
    finishedLength === 0 || finishedLength === allLength ? "loader" : "time";

  return (
    <WSProgressBar
      percent={percent}
      text={
        <WSInfoBox
          mt="S"
          theme="neutral"
          icon={descriptionIcon}
          transparent
          iconColor="blue400"
        >
          {description}
        </WSInfoBox>
      }
    />
  );
};
